import './scss/login.scss';
import 'bootstrap';
import { createApp } from 'vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import i18n from "./i18n/i18n";
import Login from "./pages/Login.vue";
import Imprint from "./pages/Imprint.vue";
import PrivacyPolicy from "./pages/PrivacyPolicy.vue";
import LoginRoot from "./components/LoginRoot.vue";

document.addEventListener("DOMContentLoaded", async () => {
    const router = createRouter({
        history: createWebHashHistory(),
        routes: [
            {path: '/', component: Login},
            {path: '/imprint', component: Imprint},
            {path: '/privacy-policy', component: PrivacyPolicy},
        ]
    });

    const app = createApp(LoginRoot);

    app.use(router);
    app.use(i18n);

    app.mount('#app');
});
